import config from '../Config';
interface FullCheckoutItem {
    email: string;
    items: CheckoutItem[];    
    dropOffLocation?: string; // Optional location for drop-off
    success_url?: string; // Optional success URL for redirection
    cancel_url?: string; // Optional cancel URL for redirection
}
interface CheckoutItem {

    Quantity: number;
    Price: string;
}

const getCheckOut = async (checkoutType: string, email: string, dropOffLocation?: string): Promise<Response> => {
    const body: FullCheckoutItem = {
        email: email,
        success_url: `${config.websiteUrl}/#/checkout-success`, // Redirect to success page
        cancel_url: `${config.websiteUrl}`, // Redirect to order page on
        items: [],
        dropOffLocation: dropOffLocation
    };
    if (checkoutType == "curbside") {
        body.email = email;
        body.items.push(


            {
                "Quantity": 1,
                "Price": "price_1MAuYWEJhvR4XSzPjjfL4dYn"
            },
            {
                "Quantity": 1,
                "Price": "price_1MAeezEJhvR4XSzPr4Gxn6jN"
            }

        );
    } else {
        body.email = email;
        body.dropOffLocation = dropOffLocation; // Include drop-off location if provided
        body.success_url = `${config.websiteUrl}/#/checkout-success`; // Redirect to success page
        body.cancel_url = `${config.websiteUrl}`; // Redirect to order page on cancel
        body.items.push(



            {
                "Quantity": 1,
                "Price": "price_1MAuYWEJhvR4XSzPjjfL4dYn"
            },
            {
                "Quantity": 1,
                "Price": "price_1MtHMCEJhvR4XSzPkWUKxf3N"
            }


        );
    }

    const checkstring: Promise<Response> = fetch(`${config.apiUrl}/StripeCheckout/6`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    console.log(checkstring);
    return checkstring;

}
export default getCheckOut;